module.exports = __webpack_public_path__ + "images/pricing-black-friday-campaign-banner.png";